import { Component, Input, Output, EventEmitter, HostListener, Renderer2, ElementRef, NgZone } from '@angular/core';
import { ChatService, ChatSession } from '../../services/chat.service';
import { formatDate } from '@angular/common';
import { Router } from "@angular/router"
import { AuthService } from '../../services/auth.service';
import { ThemeService } from "../../theme.service"
import { of, Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
// import { Overlay, OverlayRef } from '@angular/cdk';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environments/environment';
// import { normalizeStudentThemeName } from '../student-theme.util';

interface ChatItem {
  title: string
  time?: string
  active?: boolean
  section?: "saved" | "yesterday" | "history"
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  readonly enableStudentThemes = environment.enableStudentThemes ?? false;
  @Input() isOpen = false
  @Output() closeSidebar = new EventEmitter<void>()
  @Output() chatSelected = new EventEmitter<ChatSession>()
  @Output() newChatRequested = new EventEmitter<void>()


  accentColor = "#e60f0f";
  primaryColor = ""
  themeColor: string = '';
  isCollapsed = false
  chatHistory: ChatSession[] = []
  selectedSessionId: string | null = null
  pageNumber = 1; // Start from the first page
  pageSize = 20;  // Number of records per API call
  loading = false; // Prevent multiple API calls at once
  noMoreData: boolean = false;
  user: any;
  isLightTheme: boolean | undefined;
  themeApplied: any;
  pinnedSessions: any[] = [];
  groupedChatHistory: any;
  showRenameModal = false;
  showDeleteModal = false;
  sessionToEdit: any = null;
  renameInput: string = '';
  query = '';
  searchResults: any;
  page: number = 1;
  size: number = 2;
  private refreshSub!: Subscription;
  // pinnedSessions: any[] = [];
  hasMoreSessions: boolean = true;
  filteredGroupedChatHistory: any[] = []; // Search result grouped
  private searchSubject = new Subject<string>();
  private subscription!: Subscription;
  activeTab: 'threads' | 'definitions' | 'pinned' = 'threads';
  definitions: any[] = []; // For definitions tab
  constructor(private chatHistoryService: ChatService, private themeService: ThemeService,
    private renderer: Renderer2,
    private el: ElementRef,
    private ngZone: NgZone, private authService: AuthService, private router: Router,) { }

  ngOnInit() {
    this.refreshSub = this.chatHistoryService.refreshSidebar$.subscribe(() => {
      console.log('🔄 Refresh sidebar triggered');
      this.pageNumber = 1;
      this.chatHistory = [];
      this.page = 1;
      this.loading = true;
      this.pinnedSessions = []
      this.getPinnedSession();
      this.loadRefreshedChatHistory();
    });

    document.addEventListener('click', this.closeMenus.bind(this));
    this.user = this.authService.getUser();
    console.log(this.user.user, 'User')
    // const userId = this.user.user.id; 
    this.loadChatHistory()
    this.getPinnedSession();
    const savedTheme = localStorage.getItem('theme') === 'dark'; // Check if the saved theme is dark
    // this.themeService.isDarkMode$.next(savedTheme); // Update BehaviorSubject with saved theme

    this.applyTheme(); // Apply theme immediately

    console.log('theme:', savedTheme); // Debugging


    // Listen for theme changes and apply them dynamically
    // this.themeService.isDarkMode$.subscribe((isDarkMode) => {
    //   this.applyTheme(isDarkMode);
    // });

    //search Functionality
    this.subscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const userId = this.user.user.id;

        if (!query || !query.trim() || !userId) {
          return of({ results: [] }); // Skip request if query or userId is missing
        }

        const payload = {
          query: query.trim(),
          userId: userId,
          page: 1
        };

        return this.chatHistoryService.searchChat(payload);
      })
    ).subscribe({
      next: (results: any) => {
        this.chatHistory = results.results;
        this.filteredGroupedChatHistory = this.getGroupedChatHistory();
      },
      error: (err) => {
        console.error('Search error:', err);
      }
    });


  }

  //   @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent): void {
  //   this.chatHistory.forEach((session: any) => {
  //     // Close all open dropdowns if clicked outside
  //     if (!(event.target as HTMLElement).closest('.dropdown-tooltip') &&
  //         !(event.target as HTMLElement).closest('.menu-button')) {
  //       session.showMenu = false;
  //     }
  //   });
  // }

  getTotalSearchResultCount(): number {
    return this.filteredGroupedChatHistory.reduce((total, group) => total + group.sessions.length, 0);
  }
  onQueryChange(query: string): void {
    if (!query || !query.trim()) {
      this.chatHistory = []; // Optional: clear search results
      return; // 🚫 Don't send empty search requests
    }

    this.searchSubject.next(query.trim());
  }

  clearSearch() {
    this.query = '';
    this.chatHistory = [];// Optional: trigger search update
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.refreshSub?.unsubscribe();
  }
  // private applyTheme(): void {
  //   this.themeApplied = this.user.user.theme.name;

  //   const allThemes = ['light-theme', 'dark-theme', 'space-theme', 'cricket-theme', 'sunset-theme'];

  //   // Remove all existing theme classes from body
  //   allThemes.forEach(theme => this.renderer.removeClass(document.body, theme));

  //   switch (this.themeApplied) {
  //     case 'default':
  //       this.renderer.addClass(document.body, 'light-theme');
  //       this.isLightTheme = true;
  //       break;

  //     case 'custom':
  //       this.renderer.addClass(document.body, 'light-theme');
  //       this.primaryColor = this.user.user.theme.customTheme.primaryColor;
  //       this.themeColor=this.user.user.theme.customTheme.accentColor;
  //       this.isLightTheme = true; // Or false depending on your color logic
  //       break;
  //     case 'nebula_way':
  //       this.renderer.addClass(document.body, 'dark-theme-sidebar');
  //       this.isLightTheme = false;
  //       break;
  //     case 'sunrise_splash':
  //       this.renderer.addClass(document.body, 'light-theme');
  //       this.isLightTheme = true;
  //       break;
  //     case 'space_explorer':
  //       this.renderer.addClass(document.body, 'space-theme');
  //       this.isLightTheme = false;
  //       break;
  //     case 'cricket_fever':
  //       this.renderer.addClass(document.body, 'cricket-theme');
  //       this.isLightTheme = true;
  //       break;
  //     case 'sunset_wave':
  //       this.renderer.addClass(document.body, 'sunset-theme');
  //       this.isLightTheme = false;
  //       break;
  //     default:
  //       this.renderer.addClass(document.body, 'light-theme');
  //       this.isLightTheme = true;
  //   }
  // }

  // private applyTheme(isDark: boolean): void {
  //   this.themeApplied=this.user.user.theme.name;
  //   // this.isLightTheme = !isDark;
  //   // const savedTheme = localStorage.getItem('theme') || 'light'; // Default to light
  //   // document.body.classList.toggle('dark', savedTheme === 'dark');
  //   // if (isDark) {
  //   //   this.renderer.addClass(this.el.nativeElement, "dark-theme")
  //   //   this.renderer.removeClass(this.el.nativeElement, "light-theme")
  //   // } else {
  //   //   this.renderer.addClass(this.el.nativeElement, "light-theme")
  //   //   this.renderer.removeClass(this.el.nativeElement, "dark-theme")
  //   // }
  // }
  private applyTheme(): void {
    this.themeApplied = this.user.user.theme.name;
 

    const allThemes = ['light-theme', 'dark-theme', 'space-theme', 'cricket-theme', 'sunset-theme', 'camp_wings', 'jump_shot'];

    // Remove all existing theme classes from body
    allThemes.forEach(theme => this.renderer.removeClass(document.body, theme));
    const root = document.documentElement;
    switch (this.themeApplied) {
      case 'custom':
        this.renderer.addClass(document.body, 'light-theme');
        this.themeColor = this.user.user.theme.customTheme.accentColor;
        this.primaryColor = this.user.user.theme.customTheme.primaryColor;
        root.style.setProperty('--scrollbar-thumb-color', this.themeColor = this.user.user.theme.customTheme.accentColor);


        this.isLightTheme = true;
        break;
      case 'nebula_way':
        this.renderer.addClass(document.body, 'dark-theme');
        this.isLightTheme = false;
        break;
      case 'spin_and_swing':
        this.renderer.addClass(document.body, 'light-theme');
        this.renderer.addClass(document.body, 'cricket-theme');
        this.isLightTheme = true;
        break;
      case ' learning_lane':
        this.renderer.addClass(document.body, '');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = false;
        break;
      case 'cricket_fever':
        this.renderer.addClass(document.body, 'cricket-theme');
        this.isLightTheme = true;
        break;
      case 'camp_wings':
        this.renderer.addClass(document.body, 'camp_wings');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = false;
        break;
      case 'jump_shot':
        this.renderer.addClass(document.body, 'jump_shot');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = true;
        break;
      // case 'rainbow':
      // case 'mango':
      // case 'rocket':
      // case 'ice_cream':
      // case 'learning_lane':
      // case 'default':
      //   this.renderer.addClass(document.body, 'light-theme');
      //   this.isLightTheme = true;
      //   break;
      default:
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = true;
    }
    // this.setGreeting();
  }
  loadRefreshedChatHistory() {
    // ✅ Prevent multiple calls if no more data

    this.loading = true;
    const userId = this.user.user.id;
    console.log(this.user, 'Sidebar')
    this.chatHistoryService.getChatHistory(1, userId, null).subscribe(
      (history: any) => {
        if (history.data.length > 0) {
          history.data.forEach((session: any) => {
            session.sessionName = session.sessionName || session.chats?.[0]?.query;
            session.category = this.getSessionCategory(session.updatedAt);
          });

          this.chatHistory.push(...history.data); // ✅ Append new data
          this.pageNumber++; // ✅ Increase page count
          this.groupedChatHistory = this.getGroupedChatHistory();
          console.log('groupedChatHistory:', this.groupedChatHistory);
        } else {
          this.noMoreData = true; // ✅ Stop loading if no more data
        }
        this.loading = false; // ✅ Hide loader when done
      },
      (error: any) => {
        console.error("Error fetching chat history:", error);
        this.loading = false;
      }
    );
  }
  loadChatHistory() {
    if (this.loading || this.noMoreData) return; // ✅ Prevent multiple calls if no more data

    this.loading = true;
    const userId = this.user.user.id;
    console.log(this.user, 'Sidebar')
    this.chatHistoryService.getChatHistory(this.pageNumber, userId, null).subscribe(
      (history: any) => {
        if (history.data.length > 0) {
          history.data.forEach((session: any) => {
            session.sessionName = session.sessionName || session.chats?.[0]?.query;
            session.category = this.getSessionCategory(session.updatedAt);
          });

          this.chatHistory.push(...history.data); // ✅ Append new data
          this.pageNumber++; // ✅ Increase page count
          this.groupedChatHistory = this.getGroupedChatHistory();
          console.log('groupedChatHistory:', this.groupedChatHistory);
        } else {
          this.noMoreData = true; // ✅ Stop loading if no more data
        }
        this.loading = false; // ✅ Hide loader when done
      },
      (error: any) => {
        console.error("Error fetching chat history:", error);
        this.loading = false;
      }
    );
  }


  // loadChatHistory() {
  //   this.chatHistoryService.getChatHistory().subscribe(
  //     (history: any) => {
  //       if (history.data.length > 0) {
  //         history.data.forEach((session: any) => {
  //           if (session.chats && session.chats.length > 0) {
  //             session.sessionName = session.chats[0].query || "Untitled Session"; 
  //           } else {
  //             session.sessionName = "Untitled Session";
  //           }

  //           // Categorize based on date
  //           session.category = this.getSessionCategory(session.updatedAt);
  //         });

  //         // Sort latest first
  //         this.chatHistory = history.data.sort(
  //           (a: any, b: any) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  //         );
  //       }

  //       console.log(this.chatHistory, 'Sorted and categorized chat history');
  //     },
  //     (error) => {
  //       console.error("Error fetching chat history:", error);
  //     }
  //   );
  // }
  getSessionCategory(timestamp: string): string {
    const sessionDate = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    if (sessionDate.toDateString() === today.toDateString()) {
      return "Today";
    } else if (sessionDate.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else if (sessionDate > lastWeek) {
      return "Last Week";
    } else {
      return formatDate(sessionDate, 'MMMM', 'en-US'); // Format as "January", "February", etc.
    }
  }

  selectSession(session: ChatSession) {
    this.selectedSessionId = session.sessionId

    this.chatSelected.emit(session)
  }

  // newChat() {
  //   console.log("New chat clicked")
  //   // Implement new chat functionality
  // }

  // deleteSession(sessionId: string, event: Event) {
  //   event.stopPropagation()
  //   console.log("Delete session:", sessionId)
  //   // Implement delete functionality
  // }

  search(event: Event) {
    const value = (event.target as HTMLInputElement).value
    console.log("Search:", value)
    // Implement search functionality
  }

  // logout() {
  //   console.log("Logout clicked")
  //   // Implement logout functionality
  // }

  close() {
    this.closeSidebar.emit()
  }
  collapseButtonClicked() {
    this.closeSidebar.emit()
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed
  }
  newChat() {
    console.log('new chat clicked for new session', this.selectedSessionId)
    this.selectedSessionId = null
    this.newChatRequested.emit()
  }
  getGroupedChatHistory() {
    const grouped: Record<string, any[]> = {};

    this.chatHistory.forEach((session) => {
      // Initialize editing flag if it's not already set
      if (session.editing === undefined) {
        session.editing = false;
      }
      if (session.showMenu === undefined) {
        session.showMenu = false;
      }

      const category = session.category;
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(session);
    });

    return Object.entries(grouped).map(([category, sessions]) => ({ category, sessions }));
  }

  logout(): void {
    this.authService.logoutUser()
    this.router.navigate(["/login"])
  }
  @HostListener('window:scroll', [])
  onScroll(event?: Event): void {
    if (this.noMoreData) return;

    let bottomReached: boolean;
    if (event?.target instanceof HTMLElement) {
      const el = event.target as HTMLElement;
      bottomReached = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;
    } else {
      bottomReached = window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;
    }
    if (bottomReached) {
      this.loadChatHistory();
    }
  }
  // getPinnedSession() {
  //   const userId = this.user.user.id;
  //   this.chatHistoryService.getPinnedSessions(userId).subscribe(
  //     (data) => {
  //       this.pinnedSessions = data.pinnedSessions.map((session: any) => ({
  //         ...session,
  //         color: this.getRandomColor() // Assign random color to each session
  //       }));
  //       console.log('Pinned Sessions:', this.pinnedSessions);
  //     },
  //     (error) => {
  //       console.error('Error fetching pinned sessions:', error);
  //     }
  //   );
  // }
  getPinnedSession() {
    const userId = this.user.user.id;

    this.chatHistoryService.getPinnedSessions(userId, this.page, this.size).subscribe(
      (data: any) => {
        const newSessions = data.pinnedSessions.map((session: any) => ({
          ...session,
          color: this.getRandomColor()
        }));

        // Append new sessions
        this.pinnedSessions = [...this.pinnedSessions, ...newSessions];

        // Update hasMoreSessions based on total pages
        const totalPages = data.pagination.totalPages;
        this.page++;

        this.hasMoreSessions = this.page <= totalPages;

        console.log('Loaded Page:', this.page - 1, 'Sessions:', newSessions);
      },
      (error: any) => {
        console.error('Error loading more sessions:', error);
      }
    );
  }


  // Function to generate random color
  // getRandomColor() {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // }


  // toggleMenu(sessionId: string, event: MouseEvent) {
  //   event.stopPropagation();
  //   this.getGroupedChatHistory().forEach(group => {
  //     group.sessions.forEach(session => {
  //       session.showMenu = (session.sessionId === sessionId) ? !session.showMenu : false;
  //     });
  //   });
  // }

  renameSession(session: any) {
    console.log('Rename:', session);
    // Implement your rename logic here
  }

  deleteSession(session: any) {
    console.log('Delete:', session);
    // Implement your delete logic here
  }
  toggleMenu(sessionId: string, event: MouseEvent, isPinned = false): void {
    event.stopPropagation();

    if (isPinned) {
      this.pinnedSessions.forEach(p => {
        p.showMenu = p.sessionId === sessionId ? !p.showMenu : false;
      });
    } else {
      this.getGroupedChatHistory().forEach(group => {
        group.sessions.forEach(s => {
          s.showMenu = s.sessionId === sessionId ? !s.showMenu : false;
        });
      });
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Check if the click is outside all open dropdowns
    for (let session of this.pinnedSessions) {
      // Adjust this condition to target your menu elements properly
      const dropdownElement = document.getElementById(`dropdown-${session.id}`);
      if (dropdownElement && !dropdownElement.contains(target)) {
        session.showMenu = false;
      }
    }
  }

  enableRename(sessionToEdit: any) {
    console.log("Renaming session:", sessionToEdit);
    this.chatHistory.forEach(session => {
      session.editing = (session === sessionToEdit) ? true : false;
    });
  }


  saveRename(session: any) {
    session.editing = false;
    // You can call your API or update logic here
  }
  // ngOnInit() {
  //   document.addEventListener('click', this.closeMenus.bind(this));
  // }

  closeMenus() {
    this.getGroupedChatHistory().forEach(group => {
      group.sessions.forEach(s => s.showMenu = false);
    });
  }
  getRandomColor() {
    const colors = ['#C7866E', '#64119C'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  showTooltip: boolean = false;

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }
  goToProfile() {
    console.log('profile Clicked')
    this.router.navigate(['/student/profile']);
  }



  openModal(type: 'rename' | 'delete', session: any) {
    this.sessionToEdit = session;

    if (type === 'rename') {
      this.renameInput = session.sessionName || ''; // preload current name
      this.showRenameModal = true;
    } else if (type === 'delete') {
      this.showDeleteModal = true;
    }
  }

  closeModal() {
    this.showRenameModal = false;
    this.showDeleteModal = false;
    this.sessionToEdit = null;
    this.renameInput = '';
  }

  confirmRename() {
    // if (this.sessionToEdit) {
    //   this.sessionToEdit.name = this.renameInput;
    //   // TODO: Save the change to backend if needed
    // }
    // this.closeModal();
    console.log('this.sessionToEdit', this.sessionToEdit)
    if (this.sessionToEdit) {
      this.chatHistoryService.renameSession(this.user.user.id, this.sessionToEdit.sessionId, this.renameInput)
        .subscribe({
          next: (res: any) => {
            this.sessionToEdit.sessionName = this.renameInput;
            this.loadChatHistory();
            setTimeout(() => {
              this.chatHistoryService.triggerRefresh();
            }, 3000);

            Swal.fire({
              icon: 'success',
              title: 'Renamed!',
              text: res.message,
              timer: 2000,
              showConfirmButton: false
            });
            this.closeModal();
          },
          error: (err: any) => {
            console.error('Rename failed:', err);
          }
        });
    }
  }

  confirmDelete() {
    if (this.sessionToEdit) {
      const userId = this.sessionToEdit.userId;
      const sessionId = this.sessionToEdit.sessionId;

      this.chatHistoryService.deleteSession(userId, sessionId).subscribe({
        next: (response: any) => {
          console.log('Session archived (soft deleted):', response);

          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'The session has been deleted successfully.',
            timer: 2000,
            showConfirmButton: false
          });

          // ✅ Reset pagination and chat history
          this.pageNumber = 1;
          this.chatHistory = [];
          this.noMoreData = false;

          // ✅ Reload the full history from start
          this.loadChatHistory();

          this.closeModal();
        },
        error: (err: any) => {
          console.error('Error deleting session:', err);
          this.closeModal();
        }
      });
    } else {
      this.closeModal();
    }
  }
  visiblePinnedCount: number = 4;

  showMorePinned() {
    this.visiblePinnedCount += 4;
  }

  getInitials(name: string): string {
    if (!name) return '';
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    } else {
      return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
    }
  }
  // openMenu(session: any, triggerEvent: MouseEvent) {
  //   this.selectedSession = session;

  //   if (this.overlayRef) {
  //     this.overlayRef.dispose();
  //   }

  //   const positionStrategy = this.overlay.position()
  //     .flexibleConnectedTo(triggerEvent.target as HTMLElement)
  //     .withPositions([{ originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top' }]);

  //   this.overlayRef = this.overlay.create({ positionStrategy });
  //   const portal = new TemplatePortal(this.menuTemplate, this.vcr);
  //   this.overlayRef.attach(portal);

  //   this.overlayRef.backdropClick().subscribe(() => this.overlayRef?.dispose());
  // }

  PinChat(pinnedsession: any) {
    console.log('session ', pinnedsession);

    // ✅ Close the menu immediately
    pinnedsession.showMenu = false;

    const newPinnedState = !pinnedsession.pinned;

    this.chatHistoryService.pinSession(pinnedsession.sessionId, newPinnedState).subscribe({
      next: (response: any) => {
        console.log('Pin status updated:', response);


        this.chatHistoryService.triggerRefresh();


        Swal.fire({
          icon: 'success',
          title: newPinnedState ? 'Pinned!' : 'Unpinned!',
          text: response.message || 'Chat session updated successfully.',
          timer: 2000,
          showConfirmButton: false,
        });
      },
      error: (error: any) => {
        console.error('Error pinning session:', error);
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: error?.error?.message || 'Something went wrong. Please try again later.',
        });
      }
    });
  }

  switchTab(tab: 'threads' | 'definitions' | 'pinned') {
    this.activeTab = tab;
    // Load definitions if switching to definitions tab
    if (tab === 'definitions') {
      this.loadDefinitions();
    }
  }

  loadDefinitions() {
    // TODO: Implement definitions loading logic
    // For now, using empty array
    this.definitions = [];
  }

}
